export default __webpack_public_path__ + "a97f09bcbd5e4333309b30138b0428ce.svg";